import type { NodeQuery } from "@craftjs/core";
import type { TFunction } from "i18next";
import * as React from "react";
import type { Speaker } from "src/types";

export const textPropByNodeId = (
  linkedNodes: { id: string; node: NodeQuery }[],
  nodeId: string
): string | undefined => {
  const linkedNode = linkedNodes.find((node) => node.id === nodeId);
  return linkedNode?.node.props?._text || linkedNode?.node.props?.text;
};

export function useSpeakerModal() {
  const [speaker, setSpeaker] = React.useState<Speaker | null>();

  return {
    speaker,
    setSpeaker,
  };
}

export const getSocialLinkAriaLabel = (
  speakerName: string,
  platform: string,
  t: TFunction
) => `${speakerName} ${platform} (${t("common.opens-in-new-window")})`;
